/**
 * Error types shared between `lib/api/client.ts` and `lib/monitoring.ts`.
 * Kept in their own module (no dependencies) so those two files - the client
 * reports failures through monitoring, and monitoring switches on the error
 * shape the client throws - never form an import cycle.
 */

/** A structured error the server returned, e.g. `{ code: 'PHONE_TAKEN' }`. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: Record<string, unknown>;
  constructor(
    status: number,
    code: string,
    message: string,
    details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/** The request could not be completed within its deadline; the outcome is unknown. */
export class ApiTimeoutError extends Error {
  constructor() {
    super('Request timed out');
    this.name = 'ApiTimeoutError';
  }
}
